import React from 'react';

interface SectionOption {
  displayName: string;
}

interface Props {
  name: string;
  position: string;
  role1: string;
  role2: string;
  phonePrivate: string;
  sectionKey: string;
  sections: Record<string, SectionOption>;
  setName: (value: string) => void;
  setPosition: (value: string) => void;
  setRole1: (value: string) => void;
  setRole2: (value: string) => void;
  setPhonePrivate: (value: string) => void;
  setSectionKey: (value: string) => void;
}

const SignatureForm: React.FC<Props> = ({
  name,
  position,
  role1,
  role2,
  phonePrivate,
  sectionKey,
  sections,
  setName,
  setPosition,
  setRole1,
  setRole2,
  setPhonePrivate,
  setSectionKey,
}) => {
  return (
    <form>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ihr Name"
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Funktion bei LT</label>
        <input
          type="text"
          className="form-control"
          value={position}
          onChange={(e) => setPosition(e.target.value)}
          placeholder="Ihre Funktion"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Laterna.Tech Mailadresse</label>
        <input
          type="text"
          className="form-control"
          value={role1}
          onChange={(e) => setRole1(e.target.value)}
          placeholder="...@laterna.tech"
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Laterna.Tech Durchwahl</label>
        <input
          type="text"
          className="form-control"
          value={role2}
          onChange={(e) => setRole2(e.target.value)}
          placeholder="+49 (0) 7071 138 ..."
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Private Telefonnummer (optional)</label>
        <input
          type="text"
          className="form-control"
          value={phonePrivate}
          onChange={(e) => setPhonePrivate(e.target.value)}
          placeholder="Optional"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Standort</label>
        <select
          className="form-select"
          value={sectionKey}
          onChange={(e) => setSectionKey(e.target.value)}
        >
          {Object.entries(sections).map(([key, option]) => (
            <option key={key} value={key}>
              {option.displayName}
            </option>
          ))}
        </select>
      </div>
    </form>
  );
};

export default SignatureForm;
